import { render, staticRenderFns } from "./MobileDrawer.vue?vue&type=template&id=54be94bc&scoped=true&"
import script from "./MobileDrawer.vue?vue&type=script&lang=js&"
export * from "./MobileDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MobileDrawer.vue?vue&type=style&index=0&id=54be94bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be94bc",
  null
  
)

export default component.exports